// extracted by mini-css-extract-plugin
export default {"container":"BusinessContinuityPolicyPage_container__Gxs6x"};